import React from "react";
import { NodeViewWrapper, type ReactNodeViewProps } from "@tiptap/react";
import { Skeleton } from "@mui/material";

export default (props: ReactNodeViewProps<HTMLLabelElement>) => {
  const { width, height } = props.node.attrs;
  return (
    <NodeViewWrapper
      className="image-placeholder"
      style={{ maxWidth: "100%", height }}
    >
      <Skeleton variant="rectangular" width={width} height={height} />
    </NodeViewWrapper>
  );
};
